import React, { PureComponent } from 'react';
import { userRole } from '../../../../utils';
import { Button, ButtonColors, Panel, SideBar, UserSummary } from '../../../components/index';
import { validateFreemiumForm } from '../detail/FormValidator';
import './freemiumCreation.scss';

export class FreemiumCreation extends PureComponent {

  state = {
    checkForm: false,
  };

  onClickValidate = () => {
    this.setState({
      checkForm: true,
    });
  };

  saveFreemium = (isValid, freemium) => {
    this.setState({
      checkForm: false,
    });

    if (isValid) {
      this.props.createFreemium(freemium);
    }
  };

  render() {
    const {strings} = this.props;
    const {checkForm} = this.state;

    return (
      <div id={'freemium-creation-screen'}>
        <div className={'side-bar'}>
          <SideBar />
        </div>
        <div className={'freemium-creation'}>
          <Panel>
            <UserSummary
              userFound={false}
              strings={strings}
              checkForm={checkForm}
              validateUserForm={validateFreemiumForm}
              updateUser={this.saveFreemium}
              user={{role: userRole.FREEMIUM}}
              creationMode={true}/>
          </Panel>
          <Button
            color={ButtonColors.green}
            label={strings('create')}
            action={this.onClickValidate}
          />
        </div>
      </div>
    );
  }
}

